var i18nInstance;
export function setI18n(instance) {
  i18nInstance = instance;
}
export function getI18n() {
  return i18nInstance;
}


//////////////////
// WEBPACK FOOTER
// ./~/react-i18next/dist/es/i18nInstance.js
// module id = 468
// module chunks = 0